<template>
    <BaseDialog
      ref="baseDialog"
      modal-id="detachChapterSubjectDialog"
      title="فصل الرابط"
      confirm-text="فصل"
      confirm-variant="danger"
      @confirm="handleConfirm"
    >
      <template #body>
        <p>هل أنت متأكد أنك تريد فصل الرابط بين 
          <strong>{{ combinedName }}</strong>؟
        </p>
        <p class="text-danger">لا يمكن التراجع عن هذا الإجراء.</p>
      </template>
    </BaseDialog>
  </template>
  
  <script setup>
  import { ref, defineEmits, defineExpose } from 'vue';
  import BaseDialog from '@/components/common/BaseDialog.vue';
  
  const baseDialog = ref(null);
  const combinedName = ref('');
  const chapterSubjectId = ref(null);
  
  const open = (chapterSubject) => {
    combinedName.value = chapterSubject.name || 'غير محدد';
    chapterSubjectId.value = chapterSubject.id;
    baseDialog.value?.openDialog();
  };
  
  const emit = defineEmits(['delete']);
  
  const handleConfirm = () => {
    emit('delete', chapterSubjectId.value);
    baseDialog.value?.closeDialog();
  };
  
  defineExpose({ open });
  </script>